import { defineStore } from 'pinia';
import { message } from 'ant-design-vue';
import { router } from '@src/router/index';
import { useStoreUser } from '@src/store/modules/user';
import { useStoreCity } from '@src/store/modules/city';

/** 登录弹窗状态：未登录访问受保护路由时弹出，登录成功后跳转至原目标页 */
export const useStoreLoginModal = defineStore('loginModal', () => {
    /** 弹窗是否可见 */
    const visible = ref(false);
    /** 登录成功后待跳转的路由 fullPath */
    const redirect = ref('');

    /** 打开登录弹窗，可选记录登录完成后的跳转地址 */
    const open = (options?: { redirect?: string }) => {
        redirect.value = options?.redirect || '';
        visible.value = true;
    };

    /** 关闭弹窗并清空待跳转地址（用户主动取消登录） */
    const close = () => {
        visible.value = false;
        redirect.value = '';
    };

    /** 登录完成后拉取用户与城市数据，关闭弹窗并执行 redirect 跳转 */
    const completeLogin = async () => {
        const storeUser = useStoreUser();
        const storeCity = useStoreCity();

        await storeUser.getUser();
        if (storeUser.user.userId) {
            await storeCity.initializeCityData(storeUser.user.userId);
        }

        visible.value = false;
        const target = redirect.value;
        redirect.value = '';

        if (target) {
            await router.push(target);
        }
    };

    /** 各登录方式成功后统一入口：写入 token → 提示 → 完成后续流程 */
    const handleLoginSuccess = async (token: string, successMessage = '登录成功') => {
        useStoreUser().setAuth({ token });
        message.success(successMessage);
        await completeLogin();
    };

    return {
        visible,
        redirect,
        open,
        close,
        handleLoginSuccess,
    };
});
